var map = {
	"./bucket.png": "51ce",
	"./hammer.jpg": "55e4",
	"./manynails.jpg": "4307",
	"./nail.png": "866e",
	"./shoe.jpg": "a26e",
	"./sock.png": "49b4",
	"./stick.jpg": "c75c",
	"./threenails.png": "3b8a",
	"./twonails.png": "3089"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4c81";